module.exports = __webpack_public_path__ + "media/stylesheets/images/belcy-d96e4e0f11f412f41a9af8424cb15eff.jpg";